if (!customElements.get('tpt-shop-the-look')) {
	customElements.define(
		'tpt-shop-the-look',
		class TptShopTheLook extends HTMLElement {
			connectedCallback() {
				this.hotspots = this.querySelectorAll('.tpt-shop-the-look__hotspot');
				this.boundHandleClick = this.handleClick.bind(this);
				this.boundHandleKeydown = this.handleKeydown.bind(this);

				this.addEventListener('click', this.boundHandleClick);
				document.addEventListener('keydown', this.boundHandleKeydown);
			}

			disconnectedCallback() {
				this.removeEventListener('click', this.boundHandleClick);
				document.removeEventListener('keydown', this.boundHandleKeydown);
			}

			handleClick(event) {
				const dot = event.target.closest('.tpt-shop-the-look__dot');
				const closeButton = event.target.closest('.tpt-shop-the-look__close');

				if (dot) {
					event.preventDefault();
					this.toggleHotspot(dot.closest('.tpt-shop-the-look__hotspot'));
					return;
				}

				if (closeButton) {
					event.preventDefault();
					this.closeAllHotspots();
				}
			}

			handleKeydown(event) {
				if (event.key === 'Escape') {
					this.closeAllHotspots();
				}
			}

			toggleHotspot(hotspot) {
				if (!hotspot) return;

				const isActive = hotspot.classList.contains('is-active');

				this.closeAllHotspots();

				if (!isActive) {
					hotspot.classList.add('is-active');
					hotspot.querySelector('.tpt-shop-the-look__dot')?.setAttribute('aria-expanded', 'true');
				}
			}

			closeAllHotspots() {
				this.hotspots.forEach((hotspot) => {
					hotspot.classList.remove('is-active');
					hotspot.querySelector('.tpt-shop-the-look__dot')?.setAttribute('aria-expanded', 'false');
				});
			}
		}
	);
}
